function loopBackAPIAdapter(obj, customizer) {
    const { page, pageSize, sorted, filtered } = obj;

    let filters = {};

    let where = {};

    // WHERE
    // filtered -> [ { id: "nome_campo", value: valore_campo } ];
    // filters.where
    for (let prop in filtered) {
        let val = filtered[prop];
        let id = val.id;
        let value = val.value;
        if (customizer && customizer[id]) {
            where[id] = customizer[id](value);
        }
        else {
            where[id] = {
                like: '%' + value + '%'
            };
        }
    }
    if (Object.keys(where).length) {
        filters.where = where;
    }

    // OFFSET, LIMIT
    if (pageSize && pageSize > 0) {
        filters.limit = pageSize;
        filters.skip = (page && (page * filters.limit)) || 0;
        //filters.skip = (page && filters.limit * page - filters.limit) || 0; 
    }

    // ORDER
    let order;
    if (sorted && sorted.length) {
        order = [];
        for (let i = 0; i < sorted.length; i++) {
            let sort = sorted[i];
            let orderASCDESC = 'ASC';
            if (sort.desc) {
                orderASCDESC = 'DESC';
            }
            order.push(sort.id + ' ' + orderASCDESC);
        }
    }
    if (order && order.length) {
        filters.order = order;
    }

    return filters;
}

export default loopBackAPIAdapter;


// WEBPACK FOOTER //
// ./src/components/ReactAJAXTable/adapters/loopBackAPIAdapter.js